export default "__VITE_ASSET__FvlK6NtD__"